import React from "react";

export default function OfferCard({
  logoSrc,
  amount,
  tenure,
  emi,
  buttonText,
  onButtonClick,
}) {
  return (
    <div className="bg-[#FFFFFF] rounded-[30px] shadow-lg p-4 w-full max-w-[350px] font-atkinson mx-auto">
      {/* Logo */}
      <div className="flex justify-center">
        <img src={logoSrc} alt="Finance Logo" className="h-[38px] w-[142px] object-contain" />
      </div>

      {/* Pre-approved text */}
      <div className="mt-4 py-3 border-t border-b border-gray-300">
        <p className="text-center text-[16px] text-[#006F59] py-0.5 px-3 w-fit mx-auto bg-[#CCF8E1] ">
          Pre-Approved Amount
        </p>
        <p className="text-center text-[35px] font-atkinson-bold text-gray-900">
          {amount}
          <span className="text-gray-900">*</span>
        </p>
      </div>

      {/* Tenure and EMI */}
      <div className="flex justify-center mt-2 text-[14px] text-[#000000] font-bold">
        <span>Tenure: {tenure}</span>
        <span className="mx-2">|</span>
        <span>EMI: {emi}</span>
      </div>

      {/* Claim Offer Button */}
      <button
        className="mt-4 w-full flex gap-2 justify-center items-center bg-black text-[#12F280] py-3 rounded-md  text-[14px] font-atkinson"
        onClick={onButtonClick}
      >
        {buttonText}
        <img src="/assets/img/Layer_1 (41).png" className="h-[12px] w-[12px]"/>
      </button>
    </div>
  );
}
